__turbopack_context__.v({
  "className": "LKAiXG_className",
  "variable": "LKAiXG_variable",
});
